import { Reducer } from "redux";

import {
    ARTICLE_EDIT_CHANGE_EDITOR_TYPE_REQUEST,
    ARTICLE_EDIT_CHANGE_EDITOR_TYPE_SUCCESS,
    ARTICLE_EDIT_FETCH_FAILURE,
    ARTICLE_EDIT_FETCH_REQUEST,
    ARTICLE_EDIT_FETCH_SUCCESS,
    ARTICLE_EDIT_SAVE_ARTICLE_FAILURE,
    ARTICLE_EDIT_SAVE_ARTICLE_REQUEST,
    ARTICLE_EDIT_SAVE_ARTICLE_SUCCESS,
    ArticleEditChangeEditorTypeRequestAction,
    ArticleEditChangeEditorTypeSuccessAction,
    ArticleEditFetchFailureAction,
    ArticleEditFetchRequestAction,
    ArticleEditFetchSuccessAction,
    ArticleEditSaveArticleFailureAction,
    ArticleEditSaveArticleRequestAction,
    ArticleEditSaveArticleSuccessAction,
} from "@/mk2/apps/blogs/containers/ArticleEdit/ArticleEdit.actions";
import { initialArticleEditState } from "@/mk2/apps/blogs/containers/ArticleEdit/ArticleEdit.constants";
import { tupdate } from "@/mk2/helpers/types";
import { errorMessage } from "@/mk2/reducers/errorMessage";
import { LoadingState, loadingState } from "@/mk2/reducers/loadingState";

export interface ArticleEditState {
    post: number;
    loadingState: LoadingState;
    errorMessage: string;
    editor: null;
    isConvertingBody: boolean;
    isCreatingDraft: boolean;
}

export interface ArticleEditsState {
    [key: string]: ArticleEditState;
}

const initialArticleEditsState: ArticleEditsState = {};

declare type ArticleEditsReducerAction =
    | ArticleEditFetchRequestAction
    | ArticleEditFetchSuccessAction
    | ArticleEditFetchFailureAction
    | ArticleEditChangeEditorTypeRequestAction
    | ArticleEditChangeEditorTypeSuccessAction
    | ArticleEditSaveArticleRequestAction
    | ArticleEditSaveArticleSuccessAction
    | ArticleEditSaveArticleFailureAction;

const articleEditsReducer: Reducer<ArticleEditsState, ArticleEditsReducerAction> = (
    state = initialArticleEditsState,
    action,
) => {
    switch (action.type) {
        case ARTICLE_EDIT_CHANGE_EDITOR_TYPE_REQUEST: {
            const key = `${action.username}/${action.articleSlug}`;
            return tupdate(state, {
                [key]: tupdate(state[key] || initialArticleEditState, {
                    isConvertingBody: true,
                }),
            });
        }
        case ARTICLE_EDIT_CHANGE_EDITOR_TYPE_SUCCESS: {
            const key = `${action.username}/${action.articleSlug}`;
            return tupdate(state, {
                [key]: tupdate(state[key] || initialArticleEditState, {
                    isConvertingBody: false,
                }),
            });
        }
        case ARTICLE_EDIT_FETCH_REQUEST:
        case ARTICLE_EDIT_FETCH_FAILURE: {
            const key = `${action.username}/${action.articleSlug}`;
            return tupdate(state, {
                [key]: tupdate(state[key] || initialArticleEditState, {
                    loadingState: loadingState(undefined, action),
                    errorMessage: errorMessage(undefined, action),
                }),
            });
        }

        case ARTICLE_EDIT_FETCH_SUCCESS: {
            const key = `${action.username}/${action.articleSlug}`;
            return tupdate(state, {
                [key]: tupdate(state[key] || initialArticleEditState, {
                    post: action.response.result.post,
                    loadingState: loadingState(undefined, action),
                    errorMessage: errorMessage(undefined, action),
                }),
            });
        }

        case ARTICLE_EDIT_SAVE_ARTICLE_REQUEST: {
            const key = `${action.username}/${action.articleSlug}`;
            return tupdate(state, {
                [key]: tupdate(state[key] || initialArticleEditState, {
                    isCreatingDraft: true,
                }),
            });
        }

        case ARTICLE_EDIT_SAVE_ARTICLE_SUCCESS:
        case ARTICLE_EDIT_SAVE_ARTICLE_FAILURE: {
            const key = `${action.username}/${action.articleSlug}`;
            return tupdate(state, {
                [key]: tupdate(state[key] || initialArticleEditState, {
                    isCreatingDraft: false,
                }),
            });
        }

        default:
            return state;
    }
};

export default articleEditsReducer;
